import { NAVIGATION_ROUTES } from "../../NavigationUtils";

export type PokerConfigurationPageKey =
  | "cashGameLimits"
  | "stakes"
  | "privateGames"
  | "tournaments"
  | "timebank"
  | "features";

export type PokerConfigurationPageDefinition = {
  /** Page heading, breadcrumb leaf, and sider label. */
  title: string;
  route: string;
  permission: string;
  testId: string;
};

export const POKER_CONFIGURATION_PAGES: Record<
  PokerConfigurationPageKey,
  PokerConfigurationPageDefinition
> = {
  cashGameLimits: {
    title: "Cash Game Limits",
    route: NAVIGATION_ROUTES.POKER_CONFIGURATION_CASH_GAME_LIMITS,
    permission: "poker.configuration.cash_game_limits",
    testId: "poker-config-cash-game-limits",
  },
  stakes: {
    title: "Stakes",
    route: NAVIGATION_ROUTES.POKER_CONFIGURATION_STAKES,
    permission: "poker.configuration.stakes",
    testId: "poker-config-stakes",
  },
  privateGames: {
    title: "Private Games",
    route: NAVIGATION_ROUTES.POKER_CONFIGURATION_PRIVATE_GAMES,
    permission: "poker.configuration.private_games",
    testId: "poker-config-private-games",
  },
  tournaments: {
    title: "Tournaments",
    route: NAVIGATION_ROUTES.POKER_CONFIGURATION_TOURNAMENTS,
    permission: "poker.configuration.tournaments",
    testId: "poker-config-tournaments",
  },
  timebank: {
    title: "Timebank",
    route: NAVIGATION_ROUTES.POKER_CONFIGURATION_TIMEBANK,
    permission: "poker.configuration.timebank",
    testId: "poker-config-timebank",
  },
  features: {
    title: "Features",
    route: NAVIGATION_ROUTES.POKER_CONFIGURATION_FEATURES,
    permission: "poker.configuration.features",
    testId: "poker-config-features",
  },
};

export const POKER_CONFIGURATION_PAGE_LIST = Object.values(
  POKER_CONFIGURATION_PAGES,
);

export const POKER_CONFIGURATION_PERMISSIONS = POKER_CONFIGURATION_PAGE_LIST.map(
  (page) => page.permission,
);
